import * as React from 'react'

import { useDebouncedSearch } from 'modules/core/hooks/useSearch'
import { Companies } from 'modules/core/store/collections/companies'
import companies from 'modules/core/store/collections/companies'
import type Company from 'modules/core/store/models/Company'

export interface DefaultParams {
  status: string
}

export interface UsePayrollResultFilterReturn {
  status: string
  search: string
  companies: Companies
  onSearch: (event: React.ChangeEvent<HTMLInputElement>) => void
  onStatusChange: (value: string) => void
  searchedCompanyIds: Company[] | null
}

const usePayrollResultFilters = ({
  status: defaultStatus,
}: DefaultParams): UsePayrollResultFilterReturn => {
  const [status, setStatus] = React.useState(defaultStatus)
  const { search, onSearch } = useDebouncedSearch()
  const [searchedCompanyIds, setSearchedCompanyIds] = React.useState<Company[] | null>(null)

  const onStatusChange = (value: string) => {
    setStatus(value)
  }

  const handleSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    onSearch(event)
    const filtered =
      companies.filter((company) =>
        company.attributes.name.toLowerCase().includes(event.target.value.toLowerCase())
      ) ?? null

    if (filtered) {
      const companyIds = filtered.map((item) => item.attributes.id)
      setSearchedCompanyIds(companyIds)
    }
  }

  return {
    status,
    search,
    onStatusChange,
    onSearch: handleSearch,
    companies,
    searchedCompanyIds,
  }
}

export default usePayrollResultFilters
